import type { Pages } from '@tiptap-pro/extension-pages';

import { colors } from 'theme/colors';

import { HEADER_FOOTER_PANEL_SELECTOR } from './header-footer-dom';
import { HEADER_FOOTER_ZONE_HTML, headerFooterExtensions } from './header-footer-extensions';
import { ZONE_LABELS } from './header-footer-zone';

export const pagesOptions = ({
  editableHeaderFooter,
  initialZoomPercent,
  onZoomPercentChange,
}: {
  editableHeaderFooter: boolean;
  initialZoomPercent: number;
  onZoomPercentChange?: (zoomPercent: number) => void;
}): Parameters<typeof Pages.configure>[0] => ({
  pageFormat: 'A4',
  zoom: initialZoomPercent / 100,
  onZoomChange: (zoom: number) => onZoomPercentChange?.(Math.round(zoom * 100)),
  header: HEADER_FOOTER_ZONE_HTML,
  footer: HEADER_FOOTER_ZONE_HTML,
  editableHeader: editableHeaderFooter,
  editableFooter: editableHeaderFooter,
  headerFooterExtensions,
  accentColor: colors.primary.main,
  pageGapBackground: colors.grey[200],
  overlayLabels: {
    header: ({ subType }) => (subType === 'first' ? ZONE_LABELS.header.firstPageLabel : ZONE_LABELS.header.label),
    footer: ({ subType }) => (subType === 'first' ? ZONE_LABELS.footer.firstPageLabel : ZONE_LABELS.footer.label),
  },
  // A double-click in the side panel is outside the open header or footer, but must not close it.
  onDblClickHeaderFooterPreventClose: (event) =>
    event.target instanceof Element && Boolean(event.target.closest(HEADER_FOOTER_PANEL_SELECTOR)),
});

export const readOnlyPagesOptions = (): Parameters<typeof Pages.configure>[0] =>
  pagesOptions({ editableHeaderFooter: false, initialZoomPercent: 100 });
